export default "__VITE_ASSET__zcY3Sgnm__"